namespace $ {
	const { rem } = $mol_style_unit

	$mol_style_define($bog_bhelper_app_settings, {
		width: rem(100),
	})
}
